import { IMemberByFileData } from '../../../../../../shared/interfaces/manageCollaborators';

export const hasErrors = (collaborator: IMemberByFileData) =>
  Object.values(collaborator).some((property) => property.error && property.error !== 'hasEdited');

export const clearErrosFromField = (collaborator: IMemberByFileData) => {
  Object.values(collaborator).forEach((property) => {
    if (property.error === 'hasEdited') {
      property.error = '';
    }
  });
  return collaborator;
};
